<script>
    import { createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';
    import { fetchData, getLocalServer, isUrl, isLocalPath } from '../../shared/utils/Data.svelte';
    import { sortByName, ignoreCaseSort, projectSort } from '../../shared/utils/Sort.svelte';
    import { addCircleOutline, settings, trash, pin } from 'ionicons/icons/index.mjs';
    import QrCode from "svelte-qrcode";
    import { default as short } from "short-uuid";

    export let feature;
    export let layer;
    export let isPublic;
    let link = "";
    let relative = "";
    if (!layer.id.startsWith("__") && layer.id !== "history" && layer.id !== "history_line" && layer.id !== "history_fill") {
        var baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        var pathname = window.location.pathname;
        if (window.self !== window.top) {
            var referrer = new URL(window.document.referrer);
            baseUrl = referrer.protocol + "//" + referrer.host + referrer.pathname;
            pathname = referrer.pathname;
        }
        if (layer.metadata && layer.metadata["geosync:id"]) {
            const translator = short("23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", {
                consistentLength: false,
            });
            let mapId = null;
            let featureId = null;
            try {
                mapId = translator.fromUUID(pathname.substring(pathname.lastIndexOf("/") + 1));
                featureId = translator.fromUUID(feature.properties[layer.metadata["geosync:id"]]);      
            } catch(e) {
                console.log(e);
            }
            var params = new URLSearchParams(window.location.search);
            if (mapId && featureId) {
                if (isPublic) {
                    relative = "/link/mp/" + mapId + "/" + layer.id + "/" + featureId;
                } else {
                    relative = "/link/m/" + mapId + "/" + layer.id + "/" + featureId;
                }
            } else {
                if (isPublic) {
                    relative = `${pathname}?layer=${layer.id}&feature=${feature.properties[layer.metadata["geosync:id"]]}&public`;
                } else {
                    relative = `${pathname}?layer=${layer.id}&feature=${feature.properties[layer.metadata["geosync:id"]]}`;
                }
            }
            link = window.location.protocol + "//" + window.location.host + relative;
        }
    }
</script>

<div id="stage" in:fade>
    {#if feature}
        <table class="table table-striped light">
            <tbody>
                {#if layer && layer.id}
                    <tr>
                        <td>Layer</td>
                        <td>{ layer.id }</td>
                    </tr>
                {/if}
                {#each Object.keys(feature.properties) as key}
                    {#if window.platform == "Windows" && window.apiVersion >= 2 && typeof feature.properties[key] === "string" && isLocalPath(feature.properties[key])}
                        <tr>
                            <td>{ key }</td>
                            <td><a href="javascript:void(0);" on:click="{async function() {
                                if (window.apiVersion == 2) {
                                    let [res, err]  = await fetchData(getLocalServer() + "/open", {
                                        method: "POST",
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({
                                            folder: feature.properties[key]
                                        })
                                    });
                                    if (err) {
                                        console.log(err);
                                        return;
                                    }
                                } else {
                                    var message = {
                                        type: "app:folder:open",
                                        folder: feature.properties[key]
                                    };
                                    window.chrome.webview.postMessage(JSON.stringify(message));
                                }
                            }}">{ feature.properties[key] }</a></td>
                        </tr>
                    {:else if typeof feature.properties[key] === "string" && isUrl(feature.properties[key])}
                        <tr>
                            <td>{ key }</td>
                            <td><a href={ feature.properties[key] } target="_blank">{ feature.properties[key] }</a></td>
                        </tr>
                    {:else}
                        <tr>
                            <td>{ key }</td>
                            <td>{ feature.properties[key] }</td>
                        </tr>
                    {/if}
                {/each}
                {#if link && relative}
                    <tr>
                        <td>_link</td>
                        <td><a href={ link } target="_blank">{ relative }</a></td>
                    </tr>
                    <tr>
                        <td colspan="2"><QrCode value={ link } /></td>
                    </tr>
                {/if}
            </tbody>
        </table>
    {:else}
        <div class="empty">
            <div class="empty-icon">
                <i class="svg">{@html pin.md}</i>
            </div>
            <p class="empty-title h5">No feature data</p>
        </div>
    {/if}
</div>

<style>
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
	}
    .empty .empty-icon {
        width: 150px;
        margin: auto;
    }
    .empty .empty-title {
        margin-top: 0;
        color: black;
    }
</style>